import angular from 'angular'
import './hashtags.service'

angular
  .module('admin.hashtags', ['admin.hashtags.service'])
  .controller('HashtagsCtrl', HashtagsCtrl)

/** @ngInject */
function HashtagsCtrl(
  $scope,
  $state,
  $timeout,
  $stateParams,
  HashtagsService,
  ConfigurationsService,
) {
  var vm = this
  vm.itemsOrganicTop3 = []
  vm.itemsOrganic = []
  vm.itemsDisplayed = []
  vm.itemsBlacklist = []
  vm.hashtag = {}
  vm.bkp = {}
  vm.isSearch = false

  vm.sortType = 'ts-asc'
  vm.sortReverse = true

  vm.blackTypes = [
    {
      key: 'HASHTAG_BLACKLIST',
      name: 'Hashtag Blacklist',
    },
    {
      key: 'HASHTAG_TRENDING_BLACKLIST',
      name: 'Hashtag Trending Blacklist',
    },
  ]

  vm.blacklistType = vm.blackTypes[0].key
  vm.paginationBlack = { current: 1 }

  function reloadPagination() {
    vm.oldPage = 0
    vm.perPage = 25
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  var tab = localStorage.getItem('tabhashtags')
  if (tab !== null) {
    if (tab === 'displayed') {
      $('#organic').removeClass('active')
      $('#blacklist').removeClass('active')
      $('#displayed').addClass('active')
      $('#displayedtab').addClass('active')
    } else if (tab === 'organic') {
      $('#displayed').removeClass('active')
      $('#blacklist').removeClass('active')
      $('#organic').addClass('active')
      $('#organictab').addClass('active')
    } else {
      $('#displayed').removeClass('active')
      $('#organic').removeClass('active')
      $('#blacklist').addClass('active')
      $('#blacklisttab').addClass('active')
    }
  } else {
    $('#displayed').addClass('active')
    $('#displayedtab').addClass('active')
  }

  reloadPagination()

  loadOrganic()
  loadDisplayed(1)
  loadBlackList(vm.blacklistType)

  function loadOrganic() {
    HashtagsService.list().then(function(result) {
      ConfigurationsService.list().then(function(configs) {
        var config = _.find(configs.results, { key: 'HASHTAG_TRENDING_BLACKLIST' })
        vm.blackList = _.find(configs.results, { key: 'HASHTAG_BLACKLIST' })
        vm.blackListTrending = config
        var words = config.val.split(',')
        var items = result.results
        var isRemoved = false
        for (var i = 0; i < items.length; i++) {
          for (var j = 0; j < words.length; j++) {
            if (words[j] === items[i].name) {
              items.remove(items[i])
              i--
              isRemoved = true
              break
            }
          }

          if (items[i].ts) {
            items[i].ts = new Date(
              parseInt(items[i].ts.toString().substring(0, items[i].ts.toString().length - 3)),
            )
          }
          isRemoved = false
        }

        var itemsOrganicTop3 = _.filter(items, function(o) {
          return o.top === true
        })
        var itemsOrganic = _.filter(items, function(o) {
          return o.top == false
        })
        for (var i = 0; i < itemsOrganicTop3.length; i++) {
          itemsOrganicTop3[i].o = i + 1
        }

        for (var i = 0; i < itemsOrganic.length; i++) {
          itemsOrganic[i].o = i + 4
        }
        vm.itemsOrganicTop3 = itemsOrganicTop3
        vm.itemsOrganic = itemsOrganic
      })
    })
  }

  var oldSortType
  function loadDisplayed(pageNumber, search) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    if (!search) {
      vm.isSearch = false
      HashtagsService.listDisplayed(vm.oldPage, 25, vm.sortType).then(function(result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }
        var items = result.results
        for (var i = 0; i < items.length; i++) {
          if (items[i].ts !== undefined) {
            items[i].ts = new Date(
              parseInt(items[i].ts.toString().substring(0, items[i].ts.toString().length - 3)),
            )
          }
        }
        vm.sortType = oldSortType
        vm.itemsDisplayed = items
      })
    } else {
      vm.isSearch = true
      HashtagsService.listSearchDisplayed(vm.oldPage, 25, vm.sortType, search).then(function(
        result,
      ) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }
        var items = result.results
        for (var i = 0; i < items.length; i++) {
          if (items[i].ts !== undefined) {
            items[i].ts = new Date(
              parseInt(items[i].ts.toString().substring(0, items[i].ts.toString().length - 3)),
            )
          }
        }
        vm.sortType = oldSortType
        vm.itemsDisplayed = items
      })
    }
  }

  function loadBlackList(filter) {
    ConfigurationsService.list().then(function(configs) {
      vm.paginationBlack = { current: 1 }
      vm.itemsBlacklist = []
      var config = _.find(configs.results, { key: filter })
      var words = config.val.split(',')
      var itemsBlacklist = []
      words.map(function(item) {
        itemsBlacklist.push({ name: item })
      })
      vm.itemsBlacklist = itemsBlacklist
    })
  }

  vm.pageChanged = function(newPage) {
    vm.sortType = oldSortType
    if (vm.isSearch) {
      loadDisplayed(newPage, vm.searchHashtag)
    } else {
      loadDisplayed(newPage)
    }
  }

  vm.tabDisplayed = function() {
    $('#organic').removeClass('active')
    $('#blacklist').removeClass('active')
    $('#displayed').addClass('active')
    localStorage.setItem('tabhashtags', 'displayed')
  }

  vm.tabOrganic = function() {
    $('#displayed').removeClass('active')
    $('#blacklist').removeClass('active')
    $('#organic').addClass('active')
    localStorage.setItem('tabhashtags', 'organic')
  }

  vm.tabBlacklist = function() {
    $('#displayed').removeClass('active')
    $('#organic').removeClass('active')
    $('#blacklist').addClass('active')
    localStorage.setItem('tabhashtags', 'blacklist')
  }

  vm.add = function(isTop) {
    var date = parseInt(new Date().getTime())
    vm.hashtag = {
      id: 0,
      name: '',
      o: 0,
      ts: date,
      'ts-m': date,
    }
    vm.isTop = isTop
    vm.bkp = angular.copy(vm.hashtag)
    $('#myModalAddHashtag').modal('show')
  }

  vm.edit = function(item, top3) {
    vm.isTop = top3
    vm.hashtag = angular.copy(item)
    vm.bkp = angular.copy(item)
    $('#myModalHashtag').modal('show')
  }

  vm.save = function(isCreate) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          if (vm.hashtag.o === 0 || vm.hashtag.o === '0') {
            $timeout(function() {
              swal("You can't start order with 0", '', 'warning')
            }, 250)
            return
          }

          if (!vm.hashtag.name || !vm.hashtag.o) {
            $timeout(function() {
              swal('You need to fill some field', '', 'warning')
            }, 250)
            vm.hashtag = vm.bkp
            return
          }

          if (!vm.isTop) {
            if (vm.hashtag.name.indexOf('QC-') !== -1) {
              $timeout(function() {
                swal("You can't create a hashtag that starts with #QC-", '', 'warning')
              }, 250)
              return
            }
          }

          if (vm.isTop && vm.hashtag.o > 3) {
            $timeout(function() {
              swal('The Maximum order is 3', '', 'warning')
            }, 250)
            return
          }

          if (vm.isTop && vm.itemsOrganicTop3.length > 3) {
            $timeout(function() {
              swal("You can't add more than 3 positions.", '', 'warning')
            }, 250)
            return
          }

          // in blacklist?
          var words = vm.blackList.val.split(',')
          for (var i = 0; i < words.length; i++) {
            if (words[i].toLowerCase() === vm.hashtag.name.toLowerCase()) {
              $timeout(function() {
                swal("You can't add a hashtag that is in Blacklist.", '', 'warning')
              }, 250)
              return
            }
          }

          if (!vm.isTop) {
            var items = angular.copy(vm.itemsOrganic)
            if (isCreate) {
              items.unshift(vm.hashtag)
            }

            for (var i = 0; i < items.length; i++) {
              if (items[i].name === vm.hashtag.name) {
                items[i].name = vm.hashtag.name
                if (items[i].name !== vm.hashtag.name) {
                  if (items[i].o <= parseInt(vm.hashtag.o)) {
                    items[i].o = parseInt(vm.hashtag.o) + 1
                  } else {
                    items[i].o = parseInt(vm.hashtag.o) - 1
                  }
                }
                break
              }
              var date = parseInt(new Date(items[i]['ts']).getTime() + '000')
              items[i]['ts'] = date
            }

            items = _.sortBy(items, function(item) {
              return item.o
            })
            orderList({ models: items })
            vm.hashtag = null
            vm.bkp = null
            $('#myModalHashtag').modal('hide')
            $('#myModalAddHashtag').modal('hide')
          } else {
            var itemsOrganicTop3 = angular.copy(vm.itemsOrganicTop3)

            for (var i = 0; i < itemsOrganicTop3.length; i++) {
              if (vm.hashtag.name.toLowerCase() === itemsOrganicTop3[i].name.toLowerCase()) {
                $timeout(function() {
                  swal('This hashtag already exists!', '', 'warning')
                }, 250)
                return
              }
            }

            if (isCreate) {
              itemsOrganicTop3.push(vm.hashtag)
            } else {
              for (var i = 0; i < itemsOrganicTop3.length; i++) {
                if (itemsOrganicTop3[i].name === vm.bkp.name) {
                  itemsOrganicTop3[i].name = vm.hashtag.name
                  break
                }
              }
            }

            for (var i = 0; i < itemsOrganicTop3.length; i++) {
              if (itemsOrganicTop3[i].name === vm.hashtag.name) {
                if (itemsOrganicTop3[i].o <= parseInt(vm.hashtag.o)) {
                  itemsOrganicTop3[i].o = parseInt(vm.hashtag.o) + 1
                } else {
                  itemsOrganicTop3[i].o = parseInt(vm.hashtag.o) - 1
                }
              }

              delete itemsOrganicTop3.ts
              delete itemsOrganicTop3['ts-m']
            }

            itemsOrganicTop3 = _.sortBy(itemsOrganicTop3, function(item) {
              return item.o
            })
            orderListTop({ models: itemsOrganicTop3 })

            $('#myModalHashtag').modal('hide')
            $('#myModalAddHashtag').modal('hide')
          }
        }
      },
    )
  }

  vm.addBlacklist = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text:
          'This action will add the hashtag in trending blacklist. It may take a few minutes for it to processed.',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          if (item.id === 0) {
            vm.itemsOrganic.remove(item)
            orderList({ models: vm.itemsOrganic })
            return
          }
          ConfigurationsService.list().then(function(result) {
            var config = _.find(result.results, { key: 'HASHTAG_TRENDING_BLACKLIST' })
            config.val = config.val + ',' + item.name
            ConfigurationsService.set('HASHTAG_TRENDING_BLACKLIST', { value: config.val }).then(
              function() {
                loadOrganic()
              },
            )
          })
        }
      },
    )
  }

  vm.addBlacklistDisplayed = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text:
          'This action will add the hashtag in blacklist. It may take a few minutes for it to processed.',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          ConfigurationsService.list().then(function(result) {
            var config = _.find(result.results, { key: 'HASHTAG_BLACKLIST' })
            config.val = config.val + ',' + item.name
            ConfigurationsService.set('HASHTAG_BLACKLIST', { value: config.val }).then(function() {
              loadOrganic()
            })
          })
        }
      },
    )
  }

  vm.deleteDisplayed = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: 'This action will delete the hashtag.',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          HashtagsService.remove(item.id).then(
            function(result) {
              loadDisplayed()
            },
            function(err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      },
    )
  }

  vm.reset = function() {
    swal(
      {
        title: 'Are you sure?',
        text: 'This action will reset the hashtags from the organic orders',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          HashtagsService.reset().then(function() {
            loadOrganic()
            vm.hashtag = null
            vm.bkp = null
          })
        }
      },
    )
  }

  vm.search = function(event) {
    if (event) event.preventDefault()
    var isBreak = false
    for (var i = 0; i < vm.searchHashtag.length; i++) {
      if (vm.searchHashtag[i] === '%') {
        isBreak = true
      } else {
        isBreak = false
      }
    }

    if (isBreak) {
      swal('Invalid Search Character, "%" must be entered with other text.', '', 'warning')
      return
    }

    vm.isSearch = true
    reloadPagination()
    loadDisplayed(1, vm.searchHashtag)
  }

  vm.selectBlackListType = function() {
    loadBlackList(vm.blacklistType)
  }

  vm.removeBlacklist = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text:
          'This action will remove the hashtag from blacklist. It may take a few minutes for it to processed.',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          var list = angular.copy(vm.itemsBlacklist)
          for (var i = 0; i < list.length; i++) {
            if (list[i].name === item.name) {
              list.remove(list[i])
              break
            }
          }
          var liststr = list
            .map(function(item) {
              return item.name.toString()
            })
            .toString()
          ConfigurationsService.set(vm.blacklistType, { value: liststr }).then(function() {
            loadBlackList(vm.blacklistType)
          })
        }
      },
    )
  }

  vm.disableTable = false
  vm.config = {
    animation: 150,
    onEnd: function(/** ngSortEvent */ evt) {
      vm.disableTable = true

      orderList(evt)

      $timeout(function() {
        vm.disableTable = false
      }, 250)
    },
  }

  vm.configTop = {
    animation: 250,
    onEnd: function(/** ngSortEvent */ evt) {
      vm.disableTable = true

      orderListTop(evt)

      $timeout(function() {
        vm.disableTable = false
      }, 1000)
    },
  }

  vm.sort = function(type) {
    vm.sortReverse = !vm.sortReverse
    if (vm.sortReverse) {
      vm.sortType = type + '-asc'
    } else {
      vm.sortType = type + '-desc'
    }
    if (type === 'ct-at') {
      reloadPagination()
      loadDisplayed(1, vm.searchHashtag)
      return
    } else {
      reloadPagination()
    }
    if (vm.isSearch) {
      loadDisplayed(vm.pagination.current, vm.searchHashtag)
    } else {
      loadDisplayed(vm.pagination.current)
    }
  }

  function update(items, isTop) {
    if (isTop) {
      HashtagsService.updateTop(items).then(
        function() {
          loadOrganic()
          vm.hashtag = null
          vm.bkp = null
        },
        function(err) {
          if (err.error.message === 'record not found') {
            HashtagsService.create(vm.hashtag.name).then(
              function() {
                HashtagsService.updateTop(items).then(
                  function() {
                    loadOrganic()
                    vm.hashtag = null
                    vm.bkp = null
                  },
                  function(err) {
                    swal(err.error.message, '', 'error')
                  },
                )
              },
              function(err) {
                swal(err.error.message, '', 'error')
              },
            )
          } else {
            swal(err.error.message, '', 'error')
          }
        },
      )
    } else {
      HashtagsService.update(items).then(
        function() {
          loadOrganic()
          vm.hashtag = null
          vm.bkp = null
        },
        function(err) {
          swal(err.error.message, '', 'error')
        },
      )
    }
  }

  function orderList(evt) {
    var items = evt.models
    for (var i = 0; i < items.length; i++) {
      items[i].o = i + 4
      var date = parseInt(new Date(items[i]['ts']).getTime() + '000')
      items[i].ts = date
    }
    update(items, false)
  }

  function orderListTop(evt) {
    var items = evt.models
    for (var i = 0; i < items.length; i++) {
      items[i].o = i + 1
      var date = parseInt(new Date(items[i]['ts']).getTime() + '000')
      if (isNaN(date)) {
        items[i].ts = parseInt(new Date().getTime() + '000')
      } else {
        items[i].ts = date
      }
    }
    update(items, true)
  }
}
